export class ExcelUtils{

    static toExcelFormat(selectedRows: { index: number; data: Object; }[]): string {
        let value = '';
  
        if ( selectedRows.length == 0 ){
            return;
        }
  
        let columns:number = Object.keys(selectedRows[0].data).filter(z=>z!='$$REFERENCES').length;
        
  
        Object.keys(selectedRows[0].data).filter(z=>z!='$$REFERENCES').forEach(d=>{
            value += d+'\t'
        });
        
        value += '\n';
  
        selectedRows.forEach(x=>{
          for (var id =0 ; id<columns; id++){
            
            let columnname = Object.keys(x.data)[id];
            if ( columnname !='$$REFERENCES'){
              value += x.data[columnname]+'\t';
            }
          }
          value += '\n';
        });
  
        return value;
    }

    static toExcelFormatCell(selectedRows: { index: number; data: Object; }[],selectedIndex:number,columnName:string): string {
        let value = '';
  
        if ( selectedRows.length == 0 ){
            return;
        }
  
        value = selectedRows.find(d=>d.index == selectedIndex).data[columnName];
        return value;
    }


     static unsecuredCopyToClipboard(text) {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Unable to copy to clipboard', err);
        }
        document.body.removeChild(textArea);
      }
}